import styled from '@emotion/styled';
import { tokens, IconButton, Link } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';
import { ErrorBoundary } from '@hotjar/error-handler';
import { Commenters } from '../Commenters/Commenters';

const Comments = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
`;

const CommentCount = styled.span`
  ${tokens.text('caption')}
  color: ${tokens.color.text_light};
  white-space: nowrap;
  margin-top: ${tokens.spacer.x1};
`;

export interface CommentSummaryProps {
  users: React.ComponentProps<typeof Commenters>['users'];
  commentCount: number;
  href: string;
  onClick?: () => void;
}

export const CommentSummary = ({
  users,
  commentCount,
  href,
  onClick,
}: CommentSummaryProps): JSX.Element => {
  const { t } = useTranslation('comment');

  return (
    <ErrorBoundary squadSentryTag="workflow">
      <Comments>
        {users.length === 0 && (
          <IconButton
            icon="comment"
            size="s"
            kind="ghost"
            tooltipText={t('summary.view')}
            onClick={onClick}
          />
        )}
        {users.length !== 0 && <Commenters onClick={onClick} users={users} />}

        {commentCount !== 0 && (
          <CommentCount>
            <Link kind="inline" href={href} onClick={onClick}>
              {t('summary.commentCount', { count: commentCount })}
            </Link>
          </CommentCount>
        )}
      </Comments>
    </ErrorBoundary>
  );
};
